import React from "react";
import { connect } from "react-firebase";
import PropTypes from "prop-types";
import { compose, mapProps, getContext } from "recompose";
import filter from "just-filter-object";

import { useDeal } from "./actions";
import { gradient } from "./util";
import ListViewRow from "./ListViewRow";

export function ListView({ deals = {}, useDeal, colors, card }) {
  const [color1, color2] = colors;

  const sorted = Object.keys(deals)
    .map(id => ({ ...deals[id], id }))
    .sort((deal1, deal2) => {
      const name1 = (deal1.name || "").toLowerCase();
      const name2 = (deal2.name || "").toLowerCase();

      return name1 < name2 ? -1 : name1 > name2 ? 1 : 0;
    });

  if (!sorted.length) {
    return null;
  }

  return (
    <div>
      <div>
        {sorted.map((deal, index) => {
          return (
            <ListViewRow
              key={deal.id}
              item={deal}
              useDeal={() => useDeal(deal.id)}
              baseColor={color1}
              card={card}
              color={gradient(color1, color2, index / sorted.length)}
            />
          );
        })}
      </div>
      <div
        style={{
          fontSize: 10,
          fontStyle: "italic",
          textAlign: "center",
          color: "white",
          padding: "10px 50px",
          backgroundColor: color2
        }}
      >
        Some exclusions apply. See stores for details.<br />Offers subject to
        change monthly.
      </div>
    </div>
  );
}

const ListViewContainer = compose(
  getContext({
    selector: PropTypes.string,
    colors: PropTypes.array,
    card: PropTypes.string
  }),
  connect((props, ref, firebase) => ({
    deals: {
      path: "/deals",
      orderByChild: "deleted",
      equalTo: null
    },
    useDeal: useDeal(ref("/deal-stats"), props.selector)
  })),
  mapProps(props => {
    const { deals = {} } = props;
    const filtered = filter(deals, (key, deal) => props.filter(deal));
    return { ...props, deals: filtered };
  })
)(ListView);

export default ListViewContainer;



// WEBPACK FOOTER //
// ./src/user/ListView.js